module.exports = __webpack_public_path__ + "static/media/DarulJannah.bf4fe070.png";